import React, { useEffect, useRef, useState } from 'react';
import { StatusBadge } from './common';
import { cn } from '../lib/utils';

const ROWS = [
  { n: 'Passport', why: 'Inherited from IND • approved', r: 'reused' },
  { n: 'Proof of address', why: 'Inherited from IND • expires in 6 days', r: 'expiring' },
  { n: 'Driving licence', why: 'AI-extracted expiry • 96% confidence', r: 'satisfied' },
  { n: 'Vehicle registration (V5C)', why: 'Approved by Priya Natarajan', r: 'satisfied' },
  { n: 'No-claims discount proof', why: 'Conditional: NCD_YEARS != "0"', r: 'pending_review' },
];

const STEPS = [
  { status: 'submitted', rows: {}, json: '"status": "SUBMITTED"', pending: '[{ "code": "NCD_CERTIFICATE", "result": "PENDING_REVIEW" }]', corr: 'corr-8f1a2b' },
  { status: 'in_review', rows: {}, json: '"status": "IN_REVIEW"', pending: '[{ "code": "NCD_CERTIFICATE", "result": "PENDING_REVIEW" }]', corr: 'corr-8f1a2c', hint: 'Claimed by Priya Natarajan' },
  { status: 'expiring_soon', rows: { 4: { r: 'satisfied', why: 'Approved • reason code n/a' } }, json: '"status": "EXPIRING_SOON"', pending: '[{ "code": "RES_ADDRESS", "result": "EXPIRING" }]', corr: 'corr-8f1a2d' },
  { status: 'compliant', rows: { 1: { r: 'satisfied', why: 'Renewed via reminder link • approved' }, 4: { r: 'satisfied', why: 'Approved • reason code n/a' } }, json: '"status": "COMPLIANT"', pending: '[]', corr: 'corr-8f1a2e', hint: 'Valid until 2027-03-14' },
];

const TONE = { satisfied: 'bg-emerald-50 text-emerald-700 border-emerald-200', reused: 'bg-teal-50 text-teal-700 border-teal-200', expiring: 'bg-orange-50 text-orange-700 border-orange-200', pending_review: 'bg-sky-50 text-sky-700 border-sky-200' };

export const LiveRecordCard = () => {
  const ref = useRef(null);
  const [step, setStep] = useState(0);
  const [visible, setVisible] = useState(false);
  const [flash, setFlash] = useState(false);
  useEffect(() => {
    const io = new IntersectionObserver(([e]) => setVisible(e.isIntersecting), { threshold: 0.4 });
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, []);
  useEffect(() => {
    if (!visible) return undefined;
    const t = setInterval(() => { setStep((s) => (s + 1) % STEPS.length); setFlash(true); setTimeout(() => setFlash(false), 700); }, 2600);
    return () => clearInterval(t);
  }, [visible]);
  const s = STEPS[step];
  return (
    <div ref={ref} data-testid="hero-live-card" className={cn('rounded-2xl border bg-white shadow-lift p-5 transition-[box-shadow,border-color] duration-500', flash ? 'border-ink-400 shadow-[0_0_0_4px_rgba(59,71,89,0.08)]' : 'border-line')}>
      <div className="flex items-center justify-between">
        <div><div className="text-xs text-ink-400">KYC-000001 • Individual motor insurance</div><div className="font-semibold text-ink-800 mt-0.5">Amelia Hartley</div></div>
        <div key={s.status} className="live-pop"><StatusBadge status={s.status} /></div>
      </div>
      <div className="mt-4 space-y-2">
        {ROWS.map((row, i) => { const o = s.rows[i] || row; return (
          <div key={row.n} className={cn('flex items-center justify-between rounded-lg border px-3 py-2 transition-colors duration-500', s.rows[i] ? 'border-emerald-200 bg-emerald-50/40' : 'border-line')}>
            <div><div className="text-sm text-ink-800">{row.n}</div><div key={o.why} className="text-[11px] text-ink-400 live-fade">{o.why}</div></div>
            <span key={o.r} className={cn('live-pop text-[11px] font-medium rounded-md border px-2 py-0.5', TONE[o.r])}>{o.r.replace('_', ' ')}</span>
          </div>
        ); })}
      </div>
      <div className="mt-4 rounded-lg bg-ink-800 text-paper-50 font-mono text-[11px] p-3 leading-relaxed relative overflow-hidden">
        <span className={cn('absolute right-3 top-2.5 h-1.5 w-1.5 rounded-full transition-colors duration-500', s.status === 'compliant' ? 'bg-emerald-400' : 'bg-sky-400', visible && 'live-blink')} />
        {'{ '}<span key={s.json} className="live-fade">{s.json}</span>{', "ruleSetVersion": 1, "parentRuleSetVersion": 2,\n  "pendingItems": '}<span key={s.pending} className="live-fade">{s.pending}</span>{',\n  "correlationId": "'}<span key={s.corr} className="live-fade">{s.corr}</span>{'" }'}
        {s.hint && <div key={s.hint} className="live-fade mt-1 text-ink-300">{'// '}{s.hint}</div>}
      </div>
      <div className="mt-3 flex items-center gap-1.5">{STEPS.map((_, i) => <button key={i} type="button" data-testid={`hero-dot-${i}`} aria-label={`Show state ${i + 1}`} onClick={() => setStep(i)} className={cn('h-1 rounded-full transition-[width,background-color] duration-400', i === step ? 'w-6 bg-ink-700' : 'w-2 bg-line hover:bg-ink-300')} />)}<span className="ml-auto text-[10px] uppercase tracking-[0.14em] text-ink-400 font-semibold">Live status</span></div>
    </div>
  );
};
